import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkEmailValidity, userLogin, saveUserProfile, saveUserToken } from '../actions/user';

import { Login } from '../components/login';

const mapState = state => ({
  isLoggedIn: state.user.isLoggedIn,
  isEmailValid: state.user.isEmailValid
});

const mapDispatch = {
  checkEmailValidity,
  userLogin,
  saveUserProfile,
  saveUserToken
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(Login)
);
